import React from 'react';

const KakaoChannel = () => {
  const openKakaoChannel = () => {
    window.open('http://pf.kakao.com/_EYYBn/chat', '_blank');
  };

  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
    backgroundColor: '#FEE500',
    color: '#000000',
    padding: '8px 16px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: '500'
  };

  const iconStyle = {
    width: '24px',
    height: '24px',
    marginRight: '8px'
  };

  return (
    <div 
      style={buttonStyle} 
      onClick={openKakaoChannel}
      onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
      onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
    >
      <img 
        style={iconStyle}
        src="https://img.icons8.com/color/24/000000/kakaotalk.png" 
        alt="카카오 아이콘" 
      />
      카카오 문의하기
    </div>
  );
};

export default KakaoChannel;